import { createFileRoute } from '@tanstack/react-router';

import { HarnessPage } from '@/features/admin-terminal/components/harness';

/**
 * The chatbot Harness. Live mode reads production traffic from the deployed
 * API; the replay tabs answer 404 away from a local stack and say so.
 */
export const Route = createFileRoute('/_admin/admin/harness')({
  validateSearch: (search: Record<string, unknown>) => ({
    conversationId:
      typeof search.conversationId === 'string' &&
      search.conversationId.length <= 200
        ? search.conversationId
        : undefined,
  }),
  component: () => (
    <HarnessPage initialConversationId={Route.useSearch().conversationId} />
  ),
});
